import OrbitControls from 'three-orbitcontrols'
import * as THREE from 'three'
import { Simulation, CamposValue, AdditionalCamPos } from 'types/data';
import { AnimationClip } from 'three';
import { SimulationType } from 'types/app';
import CameraTraveler from 'lib/cameratraveler/camera.traveler';
import { } from 'types/data'
import { Effect } from 'lib/sound';
import nativeAnimations from './nativeAnimations';
import { debounce } from 'throttle-debounce'
import { BOX_POSITION, AFTER_BOX_OUT_POS, BOX_POSITION_MOB } from 'constants/threeConstants';
import { AnimationAction } from 'three/src/animation/AnimationAction';


interface SimulationProps {
  camera: THREE.PerspectiveCamera,
  controls: OrbitControls,
  simulations: Simulation[],
  setPositionReady: Function,
  onNativeSimEnd: Function,
  mixer: THREE.AnimationMixer,
  truck: THREE.Scene,
  traveler: CameraTraveler,
  setEnginePower: Function,
  animations?: THREE.AnimationClip[]
}

interface CsimProps {
  animations: AnimationClip,
  data: Simulation,
  mixer: THREE.AnimationMixer,
  setEnginePower: Function,
  staticAnimation?: AnimationClip,
  truck: THREE.Scene,
  onNativeEnd: Function,
}

class CSimulation {
  props: CsimProps  
  startPosition: CamposValue
  id: any
  action: AnimationAction | null
  soundEffects: Effect[]
  staticAction?: AnimationAction
  nativeAnimation?: any
  counter?: {
    min: number,
    max: number,
    type: string,
    current: number,
    wasFinished: boolean,
    duration: number,
  }

  constructor(props: CsimProps) {
    this.props = props  

    this.soundEffects = props.data.sound.map(item => new Effect(item, () => {}, Boolean(this.props.data.loopSound || this.props.data.counter)))
    this.startPosition = props.data.campos[Object.keys(props.data.campos)[0]]
    this.id = props.data.id
    if(props.data.counter) {
      this.counter = {...props.data.counter, current: -1, wasFinished: false}
      this.soundEffects.forEach(item => item.setLoop(true))
    }
    this.action = props.animations ? 
      props.mixer.clipAction(props.animations)
      :
      null

    this.staticAction = props.staticAnimation ? 
      props.mixer.clipAction(props.staticAnimation)
      :
      undefined

    if (this.action) {
      this.action.loop = THREE.LoopOnce
      this.action.clampWhenFinished = true
    }

    if (props.data.nativeAnimation) {
      const { name, meshName } = props.data.nativeAnimation
      
      this.nativeAnimation = 
        nativeAnimations(name)!(props.truck.getObjectByName(meshName)!, props.onNativeEnd)
    }

    this.counterSound = debounce(500, this.counterSound)
  } 
  
  getTypedPosition(type: string) {
    return this.props.data.campos[type]
  }

  animationForwards = (forwards: Boolean) => {
    const { actionspeed } = this.props.data
    console.log(this.props.data)

    if (this.action) {
      //@ts-ignore
      const progress = (this.action!.time / this.action!._clip.duration)
      if (forwards) {
        this.soundEffects[0] && this.soundEffects[0].play(true, progress)
        
      } else {
        this.soundEffects[1] && this.soundEffects[1].play(true, 1 - progress)
      }
      
      if (forwards) {
        this.action.timeScale = actionspeed || 0.5
      } else {
        this.action.timeScale = -1 * (actionspeed || 0.5)
      }
      this.action.paused = false 
      this.action.play()

    } else if (this.nativeAnimation) {
      if (forwards) { 
        this.nativeAnimation.setPause(false, forwards)
        this.soundEffects[0] && this.soundEffects[0].play(true, 0)
      } else {
        this.soundEffects[0] && this.soundEffects[0].stop(true)
        this.nativeAnimation.setPause(false, forwards)
      }
    } else if (this.counter) {
      this.counterClicked(forwards)
    }
  }

  protected counterClicked = (forwards: Boolean) => {
    const { counter } = this
    const { setEnginePower } = this.props
    const { current, max, min } = counter!

    const targetCount = current + (forwards ? 1 : -1)
    if(forwards) {
      counter!.current = targetCount > max ? max : targetCount
    } else {
      counter!.current = targetCount < min ? min : targetCount
    }
    
    if(counter!.type === 'engine') { 
      setEnginePower(counter!.current + 1)
    }

    this.counterSound()
  }

  protected counterSound = () => {
    const { current, max } = this.counter!

    
    this.soundEffects.forEach((item, i) => i !== current && item.stop(false))
    this.soundEffects[current].play()

    if(current === max) {
      this.counter!.wasFinished = true
    }

    
    if(this.counter!.wasFinished && current === 0) {
      this.props.onNativeEnd() 
    }
  }

  animationForwardsStop = (fowrards: Boolean) => {    
    if (this.action) {
      if (fowrards) {
        this.soundEffects[0] && this.soundEffects[0].stop(true)
        this.action.paused = true
      } else {
        this.soundEffects[1] && this.soundEffects[1].stop(true)
        this.action.paused = true
      }
    } 
    if (this.nativeAnimation) {
      this.soundEffects[0] && this.soundEffects[0].stop(true)
      this.soundEffects[1] && this.soundEffects[1].stop(true)
      this.nativeAnimation.setPause(true)
    }
    // } else if (this.counter) {
    //   this.counterClicked(fowrards)      
    // }
  }

  reset(keepSound: boolean = false) {
    if (this.action) {
      this.action.reset()
      this.action.play()
      this.action.paused = true
    }
    if (this.nativeAnimation) {
      this.nativeAnimation.setPause(true)
    } 
    if (this.counter) {
      this.counter = {
        ...this.counter,
        current: -1,
        wasFinished: false
      }

    }
    this.soundEffects.forEach(item => item.stop(true))
  }

  start(truck: THREE.Scene) {
    this.initStatic()
    if (this.action) {
      this.action.reset()
      this.action.play()
      this.action.paused = true
    }

    

    const shown = this.props.data.shown_meshes
    if (shown) {
      truck.traverse(item => {
        if (shown.includes(item.name)) {
          item.visible =  true
        }
      })
    }
    if(this.counter && this.counter.type === 'engine') {
      // this.animationForwards(true)
    }
  }
  
  update() {
    if (this.nativeAnimation) this.nativeAnimation.update()
  }

  resetStatic() {
    if (this.staticAction ) {
      this.staticAction.stop()
      this.staticAction.reset()
    }
  }
  
  initStatic() {  
    if (this.staticAction ) {
      this.staticAction.play()
      this.staticAction.paused = false
    }
  }
}

export default class SimulationController {
  protected props: SimulationProps
  protected simulations: CSimulation[]
  protected sphere = THREE.Sphere.prototype
  
  constructor(props: SimulationProps) {
    const { setEnginePower } = props
    this.props = props

    this.sphere = new THREE.Box3().expandByObject(props.truck).getBoundingSphere(new THREE.Sphere())

    this.simulations = props.simulations.map((sim: Simulation) => 
      new CSimulation({
        animations: props.animations!.find(item => item.name === sim.clipName)!,
        data: sim,
        setEnginePower,
        truck: props.truck,
        mixer: this.props.mixer,
        onNativeEnd: this.props.onNativeSimEnd,
        staticAnimation: props.animations!.find(item => item.name === sim.clipNameStatic),
      })
    )

    // this.goToInitialPosition()
  }


  resetAll() {
    this.simulations.forEach(item => {
      if(item.action) {
        item.action.stop()
      }
      if(item.staticAction) {
        item.staticAction.stop()
      }
      item.soundEffects.forEach(item => item.stop())
    })
  }
  
  async startSimulation(id: any) {
    const activeSim = this.getSimById(id)
    
    activeSim.reset(true)
    
    console.log('simReset')
    
    this.props.setPositionReady(false)
    
    this.simulations.forEach(item => item.resetStatic())
    

    activeSim.start(this.props.truck)

    if(activeSim.props.data.hideMesh) {
      //@ts-ignore
      this.props.truck.getObjectByName(activeSim.props.data.hideMesh).material.opacity = 0
    }

    
    const isBox = this.props.controls!.target.z === BOX_POSITION[2] || this.props.controls!.target.z === BOX_POSITION_MOB[2]

    const concatPos = activeSim.props.data.firstPosSimType === 'MANUAL_SIMULATION' ? activeSim.props.data.additionalCamPos : undefined
    const firstConcatPos = isBox && !concatPos ? AFTER_BOX_OUT_POS : undefined
    await this.activeGoTo({ 
      id,
      initial: true, 
      concatPos,
      firstConcatPos
    });
    return this.props.setPositionReady(true);
  }

  getSimById(id: any) {
    return this.simulations.find(sim => sim.id === id)!
  }

  update(simId: any) {
    this.simulations.forEach(item => {
      if(item.props.data.id === simId) item.update()
    })
  }

  
  async activeGoTo({id, type, firstConcatPos, initial, directPosition, speed = 12, concatPos}: {id: any, directPosition?: AdditionalCamPos, type?: SimulationType, initial?: Boolean, concatPos?: AdditionalCamPos, speed?: number, firstConcatPos?: AdditionalCamPos}) {
    this.props.setPositionReady(false)
    const sim = this.getSimById(id)

    const start = {
      camera: this.props.camera.position.toArray(),
      controls: this.props.controls.target.toArray()
    }


    if (directPosition) {
      await this.props.traveler.travel({
        start: {
          ...start,
          crossPoints: {
            out: [],
            in: []
          }
        },
        end: {
          camera: directPosition.camera,
          controls: directPosition.controls
        }
      })      

      this.props.camera.userData.simPos = new THREE.Vector3(...directPosition.camera)
    } else {
      
      sim.reset(true)
      this.simulations.forEach(item =>  {
        if(item.counter) {
          item.reset()
        }
      })
      const targetType = initial ? sim.props!.data.firstPosSimType : type
      const [cx, cy, cz]  = sim.getTypedPosition(targetType!).camera
      const [sx, sy, sz]  = sim.getTypedPosition(targetType!).controls
      const { sphere } = this

      const posWasSame = this.props.camera.userData.simPos ?
        this.props.camera.userData.simPos.toArray().reduce((acc: Boolean, item: number, i: number) => 
          item !== sim.getTypedPosition(targetType!).camera[i] || !acc ?
            false 
            :
            true            
        , true)
        :
        false

      if(!posWasSame) { 
        
        await this.props.traveler.travelAroundBoundingSphere({
          start,
          speed,
          firstConcatPos,
          concatPos,
          end: {
            camera: [cx, cy, cz],
            controls: [sx, sy, sz]  
          },
        }, sphere, 40)
        
        this.props.camera.userData.simPos = new THREE.Vector3(cx, cy, cz)
        // }
      }
    }
    
    return new Promise(resolve => {
      setTimeout(() => {
        this.props.setPositionReady(true)
        resolve()
      }, 1)
    })
  }
}